import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/offer';
export function PainSection() {
  return <section className="w-full bg-forest-800 text-cream-100" aria-labelledby="dolor-titulo" data-id="element-93" data-mp="38vkeocenfju7">
      <div className="mx-auto max-w-4xl px-5 py-16 text-center lg:py-24" data-id="element-94" data-mp="2v0i1d47h2s7d">
        <h2 id="dolor-titulo" className="font-display text-3xl font-bold leading-tight sm:text-4xl" data-id="element-95" data-mp="2yxxnaqg5xztc">
          La industria del alimento balanceado nos ha mentido.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-cream-200/85" data-id="element-96" data-mp="2q0dlngee21i7">
          Le damos a nuestros "hijos de cuatro patas" comida ultra-procesada llena de químicos y
          harinas que actúan como un veneno lento.
        </p>

        <p className="mt-10 text-sm font-semibold uppercase tracking-[0.16em] text-clay-400" data-id="element-97" data-mp="228ygzgz5383s">
          Esto causa una inflamación silenciosa que:
        </p>

        <ul className="mt-6 grid gap-4 text-left sm:grid-cols-3" data-id="element-98" data-mp="27antz25x9vui">
          {painPoints.map((point, index) => <motion.li key={point} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.08,
          ease: 'easeOut'
        }} className="rounded-2xl border border-forest-700 bg-forest-900/60 p-5" data-id="element-99" data-mp="3nlfka8etew17" data-mpi={index}>
              <XCircleIcon className="mb-3 h-6 w-6 text-alert-500" aria-hidden="true" data-id="element-100" data-mp="38ugcgzlt0bio" />
              <p className="leading-relaxed text-cream-200/90" data-id="element-101" data-mp="33z9f09j4o327">{point}</p>
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-cream-100" data-id="element-102" data-mp="3dvmancy8gqzl">
          <strong className="font-semibold" data-id="element-103" data-mp="3dtt1nr05duof">No es tu culpa.</strong> Nos enseñaron que cuidar a un
          perro era abrir una bolsa de croquetas. Pero hoy, ese error le está costando años de vida
          a tu mejor amigo y mucho dinero a tu bolsillo.
        </p>
      </div>
    </section>;
}